import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib"; // TODO 过渡动画
// TODO IE9 需使用 "2015/02/15" 的格式（使用moment）
// 管理 months

import { Vue, Component, Prop, Model, Watch, Emit } from 'vue-property-decorator';
import CalendarPane from './CalendarPane.vue';
import CustomTransition from './CustomTransition.vue';
import MonthSelector from './MonthSelector.vue';
import { pageForDate } from './utils/utils';

var Calendar = /*#__PURE__*/function (_Vue) {
  _inherits(Calendar, _Vue);

  var _super = _createSuper(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.apply(this, arguments);
    _this.page = pageForDate(_this.activeDate); // private pagePrev: Calendar.Page = { year: this.page.year, month: this.page.month - 1 }
    // private pageNext: Calendar.Page = { year: this.page.year, month: this.page.month + 1 }

    _this.showMonthSelector = false;
    _this.monthSelectorInTransition = false;
    _this.paneInTransition = false;
    return _this;
  }

  _createClass(Calendar, [{
    key: "onPageChanged",
    value: function onPageChanged(page) {
      this.handlePageChange(page); // this.pagePrev = { year: this.page.year, month: this.page.month - 1 };
      // this.pageNext = { year: this.page.year, month: this.page.month + 1 };
      // this.paneInTransition = true;
      // setTimeout(() => {
      //   this.paneInTransition = false;
      // });
    }
  }, {
    key: "handlePageChange",
    value: function handlePageChange(page) {
      return page;
    }
  }, {
    key: "handleDayClick",
    value: function handleDayClick(e) {
      return e;
    }
  }, {
    key: "monthChange",
    value: function monthChange(page) {
      this.page = page;
    }
  }, {
    key: "openMonthSelector",
    value: function openMonthSelector() {
      if (this.monthSelectorInTransition) return;
      this.showMonthSelector = true;
    }
  }, {
    key: "closeMonthSelector",
    value: function closeMonthSelector() {
      var _this2 = this;

      this.monthSelectorInTransition = true;
      this.showMonthSelector = false;
      setTimeout(function () {
        _this2.monthSelectorInTransition = false;
      }, 200);
    }
  }, {
    key: "handlePrevClick",
    value: function handlePrevClick() {
      if (this.page.month <= 1) {
        this.page.year = this.page.year - 1;
        this.page.month = 12;
      } else {
        this.page.month = this.page.month - 1;
      }
    }
  }, {
    key: "handleNextClick",
    value: function handleNextClick() {
      if (this.page.month >= 12) {
        this.page.year = this.page.year + 1;
        this.page.month = 1;
      } else {
        this.page.month = this.page.month + 1;
      }
    }
  }, {
    key: "formatedActiveDate",
    get: function get() {
      var date = typeof this.activeDate === 'string' ? new Date(this.activeDate) : this.activeDate;
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    }
  }, {
    key: "formatedHighlightDays",
    get: function get() {
      return this.highlightDays.map(function (item) {
        var date = typeof item === 'string' ? new Date(item) : item;
        return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
      });
    }
  }]);

  return Calendar;
}(Vue);

__decorate([Model('dayClick', {
  type: [String, Date]
})], Calendar.prototype, "activeDate", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return 'right';
  }
})], Calendar.prototype, "titlePosition", void 0);

__decorate([Prop({
  type: Array,
  default: function _default() {
    return [];
  }
})], Calendar.prototype, "highlightDays", void 0);

__decorate([Prop({
  type: Number,
  default: function _default() {
    return 0;
  }
})], Calendar.prototype, "badge", void 0);

__decorate([Prop({
  type: [String, Date]
})], Calendar.prototype, "minDate", void 0);

__decorate([Watch('page', {
  deep: true
})], Calendar.prototype, "onPageChanged", null);

__decorate([Emit('pageChange')], Calendar.prototype, "handlePageChange", null);

__decorate([Emit('dayClick')], Calendar.prototype, "handleDayClick", null);

Calendar = __decorate([Component({
  components: {
    CalendarPane: CalendarPane,
    CustomTransition: CustomTransition,
    MonthSelector: MonthSelector
  }
})], Calendar);
export default Calendar;